import { render } from "./EditSong.vue?vue&type=template&id=033916aa"
import script from "./EditSong.vue?vue&type=script&lang=js"
export * from "./EditSong.vue?vue&type=script&lang=js"
script.render = render

export default script